import { render, staticRenderFns } from "./AnticoagulantMattress.vue?vue&type=template&id=f36013d8&"
import script from "./AnticoagulantMattress.vue?vue&type=script&lang=js&"
export * from "./AnticoagulantMattress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports